<template>
  <div class="learn-dashboard">
    <header class="topbar">
      <div class="brand">BORAlearn</div>
      <div class="spacer"></div>
      <button class="btn" @click="logout">Logout</button>
    </header>

    <main class="content">
      <h1>Hello, {{ userName }}</h1>
      <p>
        This is your learner dashboard placeholder.
        Later we’ll show your class, subjects, and quick revision links.
      </p>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import { useUiStore } from '../../stores/ui'

const router = useRouter()
const auth = useAuthStore()
const ui = useUiStore()

const userName = computed(() => auth.user?.full_name ?? 'Learner')

const logout = () => {
  auth.logout()
  ui.showToast('You have successfully logged out.', 'success')
  router.replace('/admin/login')
}

// extra safety if someone navigates here from history
onMounted(() => {
  if (!auth.isAuthenticated) {
    router.replace('/admin/login')
  }
})
</script>

<style scoped>
.learn-dashboard {
  min-height: 100vh;
  background: #f8fafc;
}

.topbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1.2rem;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.brand {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.spacer {
  flex: 1;
}

.content {
  padding: 1.5rem;
}

.btn {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  padding: 0.4rem 0.85rem;
  cursor: pointer;
}
</style>
